import React from "react";
import { Input } from "antd";

const LabeledInput = ({ name, label, value, onChange, required = false, error = false }) => (
  <div className={"ctn text " + name}>
    <label>
      {label}
      {required ? " *" : ""} :
    </label>
    <span className={error ? "error-wrap" : ""}>
      <Input
        value={value === undefined || value === null ? "" : value}
        onChange={(e) => onChange(e.target.value)}
      />
    </span>
  </div>
);

export default LabeledInput;
